import { Flex, Icon } from '@chakra-ui/react'
import { TriangleAlert, X } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { FontStyle, Text } from '~/components/core'
import { Tooltip } from '~/components/ui/tooltip'

import { asChakraVariable } from '@mangovoice/design-system'

interface ClockSkewBarProps {
  onDismiss?: () => void
}

/**
 * Presentational bar shared by the pre-login notice and the in-app banner. Owns
 * the icon, message, colors, and (optionally) the dismiss control so the two
 * surfaces can't drift apart. Detection and show/hide behavior live in the
 * hosts; this component is dumb.
 */
export const ClockSkewBar = ({ onDismiss }: ClockSkewBarProps) => {
  const { t } = useTranslation()

  return (
    <Flex
      width="100%"
      height="100%"
      paddingX="1rem"
      paddingY=".75rem"
      alignItems="center"
      justifyContent={onDismiss ? 'space-between' : 'center'}
      backgroundColor="blue.solid"
    >
      <Flex alignItems="center" gap={2}>
        <Icon boxSize="20px" color="blue.contrast" flexShrink={0}>
          <TriangleAlert size="100%" />
        </Icon>
        <Text
          fontStyle={FontStyle.Small}
          color={asChakraVariable('blue.contrast')}
          align={onDismiss ? 'left' : 'center'}
        >
          {t('clockSkewBanner.message')}
        </Text>
      </Flex>
      {onDismiss && (
        <Tooltip
          content={t('tooltips.dismiss')}
          positioning={{ placement: 'left' }}
        >
          <button
            type="button"
            onClick={onDismiss}
            aria-label={t('tooltips.dismiss')}
            style={{
              display: 'inline-flex',
              cursor: 'pointer',
              marginLeft: '0.5rem',
              padding: 0,
              border: 'none',
              background: 'none',
              color: 'inherit',
            }}
          >
            <Icon boxSize="20px" color="blue.contrast">
              <X size="100%" />
            </Icon>
          </button>
        </Tooltip>
      )}
    </Flex>
  )
}
